<!-- 福利展示 -->
<template>
  <div :class="$style['welfare-gallery']">
    <lazy-component>
      <!-- 联动视频 -->
      <div :class="$style.activities">
        <ShowcaseVideo
          v-if="welfareConfig.welfare_video"
          :video-src="welfareConfig.welfare_video"
          :video-poster="welfareConfig.welfare_video_cover"
        />
      </div>
      <div
        v-for="(item, index) in welfareContentList"
        :key="index"
        :class="$style['gallery-item']"
      >
        <img :src="item.title_img" :class="$style['item-title']" />
        <img :src="item.content_img" :class="$style['item-content']" />
      </div>
    </lazy-component>
  </div>
</template>

<script>
import { ShowcaseVideo } from "@/components/widgets";

export default {
  name: "TheWelfareGallery",
  components: {
    ShowcaseVideo
  },
  props: {
    welfareConfig: {
      type: Object,
      default: () => ({})
    },
    welfareContentList: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="less" module>
.welfare-gallery {
  .background-fill("./images/welfare-gallery-bg.jpg", contain);

  min-height: 50.72rem;
  padding-top: 2.38rem;
}

.activities {
  .size(10.55rem, 8.83rem);

  margin: 0 auto;

  // 标题
  &::before {
    .size(6.52rem, 0.76rem);
    .background-fill("./images/activities-title.png");

    content: "";
    display: block;
    margin: 0 auto 0.5rem;
    pointer-events: none;
  }
}

.item-title {
  .size(7.58rem, 1.91rem);

  display: block;
  margin: 0 auto;
}

.item-content {
  .size(10.8rem, 7.95rem);

  display: block;
  margin: 0 auto;
}
</style>
